// Preserve the environment suffix: admin-test -> agent-test, admin -> agent.
export function getAgentDashboardUrl(location) {
  const host = location.hostname.toLowerCase();
  if (host === 'localhost' || host === '127.0.0.1') {
    return `http://${host}:4001`;
  }
  if (!/^admin(?:-[a-z0-9-]+)?\./.test(host)) {
    throw new Error('无法识别当前管理端环境，请使用对应环境的管理端域名');
  }
  return `https://${host.replace(/^admin(?=[.-])/, 'agent')}`;
}
